import { servesPages } from "@citychallenge/common";
import { FC, Suspense } from "react";
import { useLocation } from "react-router-dom";

import { isViewerRoute } from "../core/viewer-route";
import { WEB_CONFIG } from "../core/web-config";
import { PagesLoader } from "../pages/components/pages-loader/pages-loader";
import { ShimmerUI } from "../ui/shimmer-ui";
import { DummyUI } from "./dummy-ui";
import { SuspenseErrorBoundary } from "./suspense-error-boundary";

export interface SuspenseShimmerWithUIProps {
  hideError?: boolean;
}

export const SuspenseShimmerWithUI: FC<SuspenseShimmerWithUIProps> = ({
  hideError,
  children,
}) => {
  const location = useLocation();

  // Boot loader for projects with pages: this fallback renders before anything
  // mounts, so the pages runtime's own boundaries can't cover a cold load or a
  // refresh. The division comes from the server-injected config, the only one
  // available this early.
  //
  // Excluded are the viewer routes, which DummyUI hands its dark canvas loader
  // because those open onto the viewer, not onto a page.
  const brandedBoot =
    servesPages(WEB_CONFIG.DIVISION_INFO) && !isViewerRoute(location.pathname);

  return (
    <Suspense
      fallback={
        brandedBoot ? (
          <PagesLoader fullScreen />
        ) : (
          <DummyUI>
            <ShimmerUI />
          </DummyUI>
        )
      }
    >
      <SuspenseErrorBoundary hideError={hideError}>
        {children}
      </SuspenseErrorBoundary>
    </Suspense>
  );
};
